import template from "./pLicenseAgreement.html";
import moment from "moment";
import countries from "theme/utils/countries.js";

export function pLicenseAgreementDirective() {
  "ngInject";

  let directive = {
    restrict: "E",
    template: template,
    controller: pLicenseAgreementController,
    controllerAs: "pLicenseAgreement",
    bindToController: true
  };

  return directive;
}

class pLicenseAgreementController {
  constructor(Auth, Notes, bModal, $routeParams, $scope, $interval, $location, $q, DownloadFile, ConnectionQuality) {
    "ngInject";

    this.Auth = Auth;
    this.Notes = Notes;
    this.bModal = bModal;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$location = $location;
    this.$q = $q;

    this.files = [];
    this.uploadedFiles = null;

    this.agreementId = $routeParams.agreementId;
    this.formId = $routeParams.formId;

    this.DownloadFile = DownloadFile;
    this.ConnectionQuality = ConnectionQuality;

    this.createdAt = moment().format("DD.MM.YYYY");
    this.countries = countries;
    this.checkboxesValidation = false;
    this.select = {
      country: {}
    };

    this.invoicingData = {
      company: {
        type: "text"
      },
      country: {
        type: "select"
      },
      address1: {
        type: "text",
        info: true
      },
      address2: {
        type: "text"
      },
      intraCommunityVatNumber: {
        type: "text",
        isNotRequired: true,
        reliantOnCh: "noIntraCommunityVat"
      },
      noIntraCommunityVat: {
        type: "checkbox_reliant",
        isNotRequired: true,
        reliantOn: "intraCommunityVatNumber"
      },
      localVatNumber: {
        type: "text",
        isNotRequired: true,
        reliantOnCh: "noLocalVat"
      },
      noLocalVat: {
        type: "checkbox_reliant",
        isNotRequired: true,
        reliantOn: "localVatNumber"
      },
      taxIdNumber: {
        type: "text",
        info: true
      },
      phoneNumber: {
        type: "number"
      },
      invoicesEmailAddress: {
        type: "email"
      }
    };

    this.contactData = {
      mainContactPersonName: {
        type: "text"
      },
      mainContactPersonEmailAddress: {
        type: "email"
      },
      mainContactPersonPhoneNumber: {
        type: "number"
      }
    };

    this.consents = {
      licenseAgreementAccepted: {
        type: "checkbox"
      },
      dataProcessingAgreementAccepted: {
        type: "checkbox"
      }
    };

    this.taxCertificateOfResidenceRequired = {
      yes: true,
      no: false
    };

    this.init();

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.select.country.values = this.countries;

    this.modalConfig = {
      hideLeftButton: "hide",
      text: "LICENSE_AGREEMENT.THANK_YOU.TEXT",
      acceptText: "LICENSE_AGREEMENT.THANK_YOU.CLOSE",
      cancelText: ""
    };


    if (this.formId) {
      this.state = "loading";

      this.Auth.getLicenseAgreementById(this.formId).then(
        ({data}) => {
          return this.Auth.getLicenseAgreementAttachments(this.formId).then((attachments) => {
            this.values = data;
            this.formState = "showOnly";
            this.createdAt = moment(data.createdAt).format("DD.MM.YYYY") || moment().format("DD.MM.YYYY");
            this.files = attachments.data;
            this.state = "loaded";
          });
        },
          error => {
            this.state = error;
            this.Notes.postNote({type: "error", error: error});
          }
        );
    } else {
      this.formState = "new";
      this.values = null;
    }

    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});
  }

  underscoreString(string) {
    return string.split(/(?=[A-Z])/).join("_").toUpperCase();
  }

  checkCheckbox(data, checkedKey) {
    Object.keys(data).map( key => {
      if (data[key].reliantOn && data[key].reliantOn == checkedKey) {
        if (this.values[checkedKey] == false) {
          this.values[key] = false;
        }
      }
    });
  }

  checkRadio(data, checked) {
    let radio = [];
    Object.keys(data).forEach( key => {
      if(data[key].type == "radio") {
        radio.push(key);
      }
    });

    radio.forEach( r => {
      if( r != checked) {
        this.values[r] = false;
      }
    });
  }

  changeTaxCertificateOfResidence() {
    this.checkRadio(this.values.taxCertificateOfResidenceRequired, this.taxCertificateOfResidenceRequired);
  }

  archivedAtIsUndefined(item) {
    return item.archivedAt === undefined;
  }

  getFileDetails() {
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      this.files.push(this.uploadedFiles[i]);
    }
    this.uploadedFiles = null;
  }

  attachAndSend() {
    this.state = "loading";
    this.validFiles = this.files;
    this.docList = [];
    const agreementId = this.agreementId;
    let promises = [];
    if (this.validFiles && this.validFiles.length) {
      Array.from(this.validFiles).forEach(file => promises.push(this.Auth.uploadLicenseAgreementFiles(file, agreementId)));
      this.$q.all(promises).then(
        () => {
          Array.from(this.validFiles).forEach(file => {
            this.docList.push(file.name);
          });
          this.validFiles = null;
          this.sendAgreement();
        },
        (error) => {
          this.state = "loaded";
          this.Notes.postNote({type: "error", error: error});
        }
      );
    } else {
      this.sendAgreement();
    }
  }

  sendAgreement() {
    const dto = {
      ...this.values,
      phoneNumber: this.values.phoneNumber.toString(),
      mainContactPersonPhoneNumber: this.values.mainContactPersonPhoneNumber.toString(),
      taxCertificateOfResidenceRequired: this.values.taxCertificateOfResidenceRequired === "true" ? true : false,
      createdAt: new Date(),
      attachments: this.docList || [],
      localVatNumber: this.values.localVatNumber || null,
      intraCommunityVatNumber: this.values.intraCommunityVatNumber || null
    };
    delete dto.noLocalVat;
    delete dto.noIntraCommunityVat;

    this.Auth.sendLicenseAgreementForm(this.agreementId, dto).then(
      (suc) => {
        this.formId = suc.data.id;
        this.state = "loaded";

        this.bModal.show(this.modalConfig).then(
          () => {
            this.state = "loading";
            this.$location.path(`/license-agreement-forms/${this.formId}`);
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      (error) => {
        this.state = "loaded";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteAttachment(key) {
    this.files.splice(key, 1);
  }

  print() {
    window.print();
  }

  getAgreementPdf() {
    this.state = "loading";
    this.Auth.getLicenseAgreementPdf().then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers,
        "KLIX_LICENSE_AGREEMENT_R&P.pdf"
      );
      this.state = "loaded";
    }).catch((error) => {
      this.state = "error";
      this.Notes.postNote({type: "error", error: error});
    });
  }
}
